import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d8ba72e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-section"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-section-title" }, "开票备注", -1))

import { ref, onMounted } from 'vue';
import {
  BaseDialog,
  BaseTextContent,
  BaseButton,
  BaseInput,
  XrkMessage,
  XrkMessageBox
} from 'xrk-components';
import {
  individualInvoiceApplySubmit,
  basicInformation,
  invoiceDetail
} from '@V/invoice/src/data-source/apis';
import type {
  IndividualInvoiceApplySubmitReqDTO,
  MakeOutAnInvoiceParams,
  CategoryGroups,
  BasicInformationData
} from '@V/invoice/src/data-source/types';
import InvoiceApplyIndividualDialogContent from './invoice-apply-individual-dialog-content.vue';
import IndividualCategoryGroup from './individual-category-group.vue';
import InvoiceOpenDialogInfo from '../invoice-open-dialog/invoice-open-dialog-info.vue';
import { useCloned } from '@vueuse/core';

type InvoiceApplyFormData = Pick<
  IndividualInvoiceApplySubmitReqDTO,
  'invoiceType' | 'theSellerId' | 'payPassagewayCode'
> & {
  payType: string;
  demand: string;
  individualId: number | null;
  individualName: string;
  receiveAt: string[];
  stateType: number;
} & Pick<
    MakeOutAnInvoiceParams,
    'itemId' | 'openOrderIds' | 'addressId' | 'auditSign'
  >;


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-apply-individual-dialog',
  props: {
    remove: { type: Function },
    id: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const show = ref(false); // 解决初始数据和获取数据后初始的部分组件延迟问题
const isConfirm = ref(false);
const contentRef = ref();
const categoryRef = ref();
const baseInfo = ref<BasicInformationData['baseInfo']>({
  entpName: '',
  entpCertNo: '',
  phone: '',
  bankName: '',
  openBankNumber: '',
  companyBusinessAddress: '',
  demand: ''
});
const addressList = ref<BasicInformationData['addressList']>([]);
const categoryGroups = ref<CategoryGroups>([
  { itemId: null, itemName: '', settlementList: [] }
]);
/* 所有表单内的数据，融合了详情接口，剔除开票数据字段 */
const formData = ref<InvoiceApplyFormData>({
  theSellerId: null,
  invoiceType: null,
  payPassagewayCode: null,
  payType: '',
  individualId: null,
  individualName: '',
  receiveAt: [],
  demand: '',
  stateType: 7,
  itemId: null,
  openOrderIds: [],
  addressId: null,
  auditSign: 1
});

const onConfirm = async () => {
  if (!isConfirm.value) {
    await categoryRef.value?.validate();
    await contentRef.value?.validate();
    isConfirm.value = true;
    return;
  }
  const [address] = addressList.value;
  const params = {
    ...baseInfo.value,
    receiptFullName: address.name,
    receiptPhone: address.phone,
    receiptAddress: address.mailAddress,
    email: address.email,
    receiptId: address.id,
    theSellerId: formData.value.theSellerId,
    invoiceType: formData.value.invoiceType,
    individualId: formData.value.individualId,
    individualName: formData.value.individualName,
    payPassagewayCode: formData.value.payPassagewayCode,
    demand: formData.value.demand,
    payType: formData.value.payType,
    receiveAt: formData.value.receiveAt,
    itemList: categoryGroups.value,
    ...(formData.value.receiveAt.length && {
      createAtStart: formData.value.receiveAt[0],
      createAtEnd: formData.value.receiveAt[1]
    }),
    ...(props.id && { invoiceApplyId: props.id })
  };

  await XrkMessageBox.confirm(
    '提交后将生效当前操作，无法撤回，请确认是否继续。',
    '确认开票',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    }
  );
  await individualInvoiceApplySubmit(params);
  XrkMessage.success('已提交开票申请');
  emits('success');
  props.remove?.();
};

const onCancel = () => {
  if (isConfirm.value) {
    isConfirm.value = false;
    return;
  }
  props.remove?.();
};

onMounted(async () => {
  const { data } = await basicInformation();
  baseInfo.value = data.baseInfo;
  addressList.value = data.addressList || [];

  if (props.id) {
    const { data: detail } = await invoiceDetail({ id: props.id });
    const d = detail as any;
    const info = d?.info || d || {};

    formData.value = {
      ...formData.value,
      ...info,
      theSellerId: info.theSellerId || info.individualId
    };

    const _itemList = d?.itemSettlementGroupList || info.itemDetailList;
    const { cloned } = useCloned(_itemList);
    categoryGroups.value = cloned.value;
  }
  show.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "950px",
    class: "form-dialog form-dialog--label120 form-dialog-invoice-custom",
    title: isConfirm.value ? '申请开票 - 确认' : '申请开票',
    "model-value": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(isConfirm.value ? '上一步' : '取消'), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), { onClick: onConfirm }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(isConfirm.value ? '确认提交' : '下一步'), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (show.value)
        ? (_openBlock(), _createBlock(_unref(BaseTextContent), { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(InvoiceOpenDialogInfo, { baseInfo: baseInfo.value }, null, 8, ["baseInfo"]),
              _createVNode(InvoiceApplyIndividualDialogContent, {
                ref_key: "contentRef",
                ref: contentRef,
                disabled: isConfirm.value,
                modelValue: formData.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData).value = $event))
              }, null, 8, ["disabled", "modelValue"]),
              (isConfirm.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _hoisted_2,
                    _createVNode(_unref(BaseInput), {
                      type: "textarea",
                      maxlength: 120,
                      rows: 2,
                      "show-word-limit": "",
                      placeholder: "请输入",
                      modelValue: formData.value.demand,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.demand) = $event))
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(IndividualCategoryGroup, {
                ref_key: "categoryRef",
                ref: categoryRef,
                categoryGroups: categoryGroups.value,
                "onUpdate:categoryGroups": _cache[2] || (_cache[2] = ($event: any) => ((categoryGroups).value = $event)),
                formData: formData.value,
                isConfirm: isConfirm.value,
                disabled: isConfirm.value
              }, null, 8, ["categoryGroups", "formData", "isConfirm", "disabled"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})